import { z } from 'zod';

import { jobArchitectureSearchItemSchema, jobArchitectureSearchResponseSchema } from './job-architecture';
import { jobLevelWithTypeSchemaTransformed } from './job-level';
import { jobRoleWithTypeSchemaTransformed } from './job-role';

/**
 * Fully hydrated role/level returned by the search endpoint when the `detail=true` query param is set.
 * Mirrors the backend `JobArchitectureItemDetail` sealed type: `{ type: 'ROLE', role } | { type: 'LEVEL', level }`.
 * Defined here (not in `job-architecture.ts`) because `job-role`/`job-level` import from `job-architecture`,
 * so composing the union there would be a circular import.
 */
export const jobArchitectureItemDetailSchema = z.discriminatedUnion('type', [
    z.object({
        role: jobRoleWithTypeSchemaTransformed,
        type: z.literal('ROLE'),
    }),
    z.object({
        level: jobLevelWithTypeSchemaTransformed,
        type: z.literal('LEVEL'),
    }),
]);

export type JobArchitectureItemDetail = z.infer<typeof jobArchitectureItemDetailSchema>;

export const jobArchitectureSearchItemWithDetailSchema = jobArchitectureSearchItemSchema.extend({
    detail: jobArchitectureItemDetailSchema.nullish(),
});

export type JobArchitectureSearchItemWithDetail = z.infer<typeof jobArchitectureSearchItemWithDetailSchema>;

export const jobArchitectureSearchResponseWithDetailSchema = jobArchitectureSearchResponseSchema.extend({
    data: z.array(jobArchitectureSearchItemWithDetailSchema),
});

export type JobArchitectureSearchResponseWithDetail = z.infer<typeof jobArchitectureSearchResponseWithDetailSchema>;
